import React, {useEffect, useMemo, useRef, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";

import {
  entityFilter,
  getFilteredAndPaginatedEntities,
  headerSortingClasses,
  sortCaret
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import {useProjectManagementUIContext} from "../ProjectManagementUIContext";
import * as actions from "../../_redux/ProjectManagementAdminAction";
import {SearchText} from "../../../../../shared/components/SearchText";
import * as moment from "moment";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import {BoootstrapTable} from "../../../../../shared/components/BoootstrapTable";

export function ProjectManagementTable() {
  const projectManagementUIContext = useProjectManagementUIContext();
  const projectManagementUIProps = useMemo(() => projectManagementUIContext, [
    projectManagementUIContext
  ]);

  const columns = [
    {
      dataField: "#",
      text: "Index",
      formatter: (cell, row, rowIndex) => {
        return <span>{(page - 1) * size + (rowIndex + 1)}</span>;
      }
    },
    {
      dataField: "project_name",
      text: "Project Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        minWidth: "165px"
      }
    },
    {
      dataField: "project_description",
      text: "Project Description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "project_status",
      text: "Project Status",
      sort: true,
      formatter: columnFormatters.ProjectStatusColumnFormatter,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "created_date",
      text: "Created Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (_, row) =>
        moment
          .utc(row?.created_date)
          .local()
            .format("DD MMMM YYYY, HH:mm:ss"),
      style: {
        minWidth: 180
      }
    },
    {
      dataField: "updated_date",
      text: "Updated Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (_, row) =>
        moment
          .utc(row?.updated_date)
          .local()
            .format("DD MMMM YYYY, HH:mm:ss"),
      style: {
        minWidth: 180
      }
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        openChangeStatusDialog:
          projectManagementUIProps.openChangeProjectManagementStatusDialog
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditProjectDialog:
          projectManagementUIProps.openEditProjectManagementDialog
      },
      style: {
        minWidth: "100px"
      }
    }
  ];

  const { currentState } = useSelector(
    state => ({
      currentState: state.projectManagementAdmin
    }),
    shallowEqual
  );

  const { entities,  totalProject,page,size } = currentState;
  const [filterEntities, setFilterEntities] = useState(entities);
  const searchInput = useRef("");
    const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  let currentItems = getFilteredAndPaginatedEntities(
    filterEntities || entities,
    projectManagementUIProps.queryParams
  );

  //Filter data for model type
  const filterProject = e => {
    // const searchStr = e?.target?.value || searchInput?.current?.value;
    const keys = [
      "project_name",
      "project_description",
      "project_status",
      "created_date",
      "updated_date"
    ];
    currentItems = entityFilter(
      entities || filterEntities,
      null,
      keys,
      projectManagementUIProps.queryParams,
      setFilterEntities
    );
  };

  //State Change Handlers
  const dispatch = useDispatch();
  useEffect(() => {
    setLoader(true);
    dispatch(actions.fetchProjects(1, 10, search));
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [ dispatch]);

  useEffect(() => {
    filterProject();
    // eslint-disable-next-line
  }, [entities]);
  const onPageChange = (page, sizePerPage) => {
    dispatch(actions.fetchProjects(page, sizePerPage, search))
  };

  const onSizePerPageChange = ( sizePerPage) => {
    dispatch(actions.fetchProjects(1, sizePerPage, search))
  };
  const onKeyPressHandler = e => {
    if (e.key === "Enter") {
      dispatch(actions.fetchProjects(1, size, search))
    }
  };

  const onChangeSearch = e => {
    const searchStr = e?.target?.value || searchInput.current.value;
    setSearch(searchStr);
  };

  return (

    <>
      <div>
        <div className=" mb-5 pagination-tab" />
        <BlockUi tag="div" blocking={loader} color="#147b82">
          <SearchText
            reference={searchInput}
            onChangeHandler={onChangeSearch}
            onKeyDown={onKeyPressHandler}
            searchField={"on PROJECT NAME , PROJECT STATUS"}

          />
          {currentItems && currentItems.length > 0 ? (
            <BoootstrapTable
              sizePerPageList={[
                { text: "10", value: 10 },
                { text: "5", value: 5 },
                { text: "3", value: 3 }
              ]}
              hideSizePerPage={false}
              showTotal={true}
              alwaysShowAllBtns={true}
              hidePageListOnlyOnePage={true}
              columns={columns}
              data={currentItems}
              sizePerPage={size}
              page={page}
              totalSize={totalProject}
              onTableChange={onPageChange}
              sizePerPageChange={onSizePerPageChange}
            />
          ) : (
            <h3 className={"table-center"}>No Data Available</h3>
          )}
        </BlockUi>
      </div>
    </>
  );
}
